const PIPELINES_URLS = window.PIPELINES_URLS;
const deviceUtilities = require('../../../utilities/deviceUtilities');
const overlay = require('../../../components/overlay');
const throttle = require('lodash/throttle');
const createSwiper = require('../../../components/swiperFactory');
const nativefy = require('../../../utilities/dom/nativefy');
const getAnalyticsEventCenter = require('../../../common/getAnalyticsEventCenter');
const cloneProductTileSizesToStickyWrapper = require('../../../product/cloneProductTileSizesToStickyWrapper');
const datalayerPublicHelpers = require('../../../components/datalayer/publicHelpers');

const analyticsEventCenter = getAnalyticsEventCenter();

/**
 * Init swiper slider.
 *
 * @param {Element|string} container - HTMLElement or string (with CSS
 * Selector) of swiper container HTML element. Required.
 * @param {Object} sliderConfig - object with Swiper parameters.
 * @returns {Promise.<Object>} - Swiper instance
 */
async function swiperInit(container, sliderConfig) {
    return createSwiper(container, {
        direction: 'horizontal',
        slidesPerColumn: 1,
        grabCursor: true,
        mousewheel: false,
        slidesPerView: 'auto',
        speed: sliderConfig.scrollAnimation ? sliderConfig.scrollAnimation.duration : 350,
        loop: sliderConfig.infiniteScroll || false,
        updateOnWindowResize: true,
        watchOverflow: true,
        scrollbar: sliderConfig.scrollbar ? {
            el: '.swiper-scrollbar',
            hide: false
        } : false,
        autoplay: sliderConfig.autoplay ? {
            delay: sliderConfig.autoplay,
            disableOnInteraction: false,
            waitForTransition: true,
            reverseDirection: false,
            pauseOnMouseEnter: true
        } : false,
        breakpoints: {
            0: {
                slidesPerView: sliderConfig.slidesNumberMobile,
                spaceBetween: sliderConfig.spacing.mobile
            },
            768: {
                slidesPerView: sliderConfig.slidesNumberDesktop,
                spaceBetween: sliderConfig.spacing.desktop
            }
        },
        on: {
            loopFix: function () {
                if (sliderConfig.infiniteScroll) {
                    const loadingImages = container.find('.pd-shop-the-look-slide__image.lazyloading');
                    loadingImages?.each(function () {
                        if ($(this).attr('src')) {
                            $(this).removeClass('lazyloading').addClass('lazyloaded');
                        }
                    });
                }
            }
        }
    });
}

/**
 * Shows bundle item sizes, only for desktop screen sizes.
 * @param {Object} shopTheLookCard Shop The Look card wrapper
 * @param {Object} associatedSizeInfo size info block to show
 */
function showDesktopShopTheLookSizes(shopTheLookCard, associatedSizeInfo) {
    overlay.createOverlay('shop-the-look-card', shopTheLookCard);
    var productCardHeight = shopTheLookCard.outerHeight(false);
    associatedSizeInfo.css('max-height', productCardHeight * 0.8 + 'px'); // The percentage of maximum height that the size selector can fill
    var associatedSizeInfoHeight = associatedSizeInfo.outerHeight(true);
    associatedSizeInfo.css('top', productCardHeight - associatedSizeInfoHeight + 'px');
}

/**
 * Closes Shop The Look size selector, in mobile and desktop
 * @param {Object} selector size info block(s) to close
 * @param {string} device Device size selector to close
 * @param {boolean} avoidTransition Remove size selector closing transition
 */
function closeShopTheLookSizeSelector(selector, device, avoidTransition) {
    if (device === 'desktop' || (!device && !deviceUtilities.isSmallerThan768())) {
        $('.shop-the-look-card-overlay').remove();
        selector.css('top', '100%');
    } else if (device === 'mobile' || deviceUtilities.isSmallerThan768()) {
        if (avoidTransition) {
            selector.addClass('no-transition');
            selector.css('bottom', '-100%');
            setTimeout(function () {
                selector.removeClass('no-transition');
            }, 400);
        } else {
            selector.css('bottom', '-100%');
        }
    }
}

/**
 * Clones bundle item sizes to a common stikcy wrapper and
 * shows it, only for mobile screen sizes.
 *
 * @param {Object} params Function params
 * @param {string} params.pid Product ID
 * @param {string} params.productImpressionId The ID of the product impression
 *  (analytics info)
 * @param {jQuery<HTMLDivElement>} params.$productTileSizesInfo Wrapper info
 *  section that contains the different sizes and related info (for instance:
 *  .product-tile__sizes-info)
 */
function showMobileShopTheLookSizes({
    pid,
    productImpressionId,
    $productTileSizesInfo
}) {
    const $destinationContainer = $('.shop-the-look-cloned-sizes');
    const $clonedSizesInfo = cloneProductTileSizesToStickyWrapper({
        pid,
        productImpressionId,
        $destinationContainer,
        $productTileSizesInfo
    });
    $clonedSizesInfo.css('bottom', '0');
}

/**
 * Initializes slider
 * @param {Element} pdSliderContainer - Slider container
 */
async function initializeSlider(pdSliderContainer) {
    var sliderConfig = {
        infiniteScroll: pdSliderContainer.data('infinitescroll'),
        slidesNumberDesktop: pdSliderContainer.data('slidesnumberdesktop'),
        slidesNumberMobile: pdSliderContainer.data('slidesnumbermobile'),
        spacing: pdSliderContainer.data('spacing'),
        scrollbar: pdSliderContainer.data('scrollbar'),
        autoplay: pdSliderContainer.data('autoplay'),
        scrollAnimation: pdSliderContainer.data('scrollanimation')
    };

    await swiperInit(pdSliderContainer, sliderConfig);
}

$(document).ready(function () {
    $('.pd-shop-the-look__swiper-container').each(function () {
        var slider = $(this);

        var shopTheLookObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.intersectionRatio > 0) {
                    $.when(initializeSlider($(entry.target))).then(function () {
                        shopTheLookObserver.unobserve(entry.target);
                    });
                }
            });
        }, { threshold: 0 });

        shopTheLookObserver.observe(slider[0]);
    });

    $('.pd-shop-the-look').on('click', '.pd-shop-the-look-slide__figure', function (e) {
        e.preventDefault();

        const currentSlideImage = $(this);
        const quickviewPids = currentSlideImage.data('quickview-pids');

        if (!quickviewPids) {
            return;
        }

        const pdComponentWrapper = $(this).closest('.pd-shop-the-look');
        pdComponentWrapper.spinner().start();

        const pdShopTheLookModal = $('.pd-shop-the-look-modal');
        pdShopTheLookModal.modal('hide');

        const currentPdShopTheLookModal = pdComponentWrapper.children('.pd-shop-the-look-modal');

        $('.pd-shop-the-look-modal .product-images-container').empty();
        $('.pd-shop-the-look-modal .product-info__wrapper').empty();

        const clonedQuickviewImage = currentSlideImage.siblings('.pd-shop-the-look-slide__quickview-image-wrapper').clone();
        clonedQuickviewImage.removeClass('d-none').appendTo('.pd-shop-the-look-modal .product-images-container');

        $.ajax({
            url: `${PIPELINES_URLS.getShopTheLookProducts}`,
            data: {
                quickviewPids: quickviewPids
            },
            type: 'post',
            dataType: 'json',
            success: function (data) {
                if (data.quickviewProductsHtml) {
                    $('.pd-shop-the-look-modal .product-info__wrapper').html(data.quickviewProductsHtml);
                    currentPdShopTheLookModal.modal('show');

                    if (currentPdShopTheLookModal.data('overlay') !== null) {
                        $('.modal-backdrop').addClass(currentPdShopTheLookModal.data('overlay'));
                    }
                }
            },
            complete: function () {
                pdComponentWrapper.spinner().stop();
            }
        });
    });

    $('.pd-shop-the-look').on('click', '.shop-the-look-card__add-to-cart', function () {
        const quickShopButton = $(this);
        const pid = quickShopButton.data('pid');
        const isUniqueSize = quickShopButton.data('unique-size');
        const isAvailable = quickShopButton.data('available');
        const shopTheLookCard = quickShopButton.closest('.shop-the-look-card');
        const $productSizesInfo = shopTheLookCard.find('.product-info__sizes-info');

        if (!isAvailable || isAvailable === 'false') {
            return;
        }

        if (isUniqueSize || isUniqueSize === 'true') {
            closeShopTheLookSizeSelector($('.shop-the-look-cloned-sizes .shop-the-look-card__sizes-info'), 'mobile');
            closeShopTheLookSizeSelector($('.shop-the-look-card .shop-the-look-card__sizes-info'), 'desktop');
            $productSizesInfo.find('.js-quickshop-option').trigger('click');
        } else if (deviceUtilities.isSmallerThan768()) {
            closeShopTheLookSizeSelector($('.shop-the-look-cloned-sizes .shop-the-look-card__sizes-info'), 'mobile');
            const productImpressionId = datalayerPublicHelpers
                .impressions
                .getProductImpressionIdFromDOM(quickShopButton.get(0));
            showMobileShopTheLookSizes({
                pid,
                productImpressionId,
                $productTileSizesInfo: $productSizesInfo
            });
        } else {
            closeShopTheLookSizeSelector($('.shop-the-look-card .shop-the-look-card__sizes-info'), 'desktop');
            showDesktopShopTheLookSizes(shopTheLookCard, $productSizesInfo);
        }
    });

    $('body').on(
        'click',
        '.pd-shop-the-look .product-sizes__close, .pd-shop-the-look .product-sizes__option:not(.disabled--unavailable)',
        function () {
            if (deviceUtilities.isSmallerThan768()) {
                closeShopTheLookSizeSelector($('.shop-the-look-cloned-sizes .product-info__sizes-info'), 'mobile');
            } else {
                closeShopTheLookSizeSelector($(this).closest('.product-info__sizes-info'), 'desktop');
            }
        }
    );

    const $pdShopTheLookModal = $('#pdShopTheLookModal');

    $pdShopTheLookModal.on('shown.bs.modal', function () {
        analyticsEventCenter.publish(
            analyticsEventCenter.EVENTS.modalShown,
            {
                modal: nativefy($pdShopTheLookModal),
                name: analyticsEventCenter.PAYLOADS.modalShown.name.shopTheLook,
                scrollableContainer: nativefy($pdShopTheLookModal.find('.col-md-6.product-info'))
            }
        );
    });

    $pdShopTheLookModal.on('hide.bs.modal', function () {
        analyticsEventCenter.publish(
            analyticsEventCenter.EVENTS.modalWillBeHidden,
            {
                modal: nativefy($pdShopTheLookModal),
                name: analyticsEventCenter.PAYLOADS.modalShown.name.shopTheLook,
                scrollableContainer: nativefy($pdShopTheLookModal.find('.col-md-6.product-info'))
            }
        );
        if (deviceUtilities.isSmallerThan768()) {
            closeShopTheLookSizeSelector($('.shop-the-look-cloned-sizes .product-info__sizes-info'), 'mobile', true);
        } else {
            closeShopTheLookSizeSelector($(this).find('.product-info__sizes-info'), 'desktop');
        }
    });

    $pdShopTheLookModal.on('hidden.bs.modal', function () {
        analyticsEventCenter.publish(
            analyticsEventCenter.EVENTS.modalHidden,
            {
                name: analyticsEventCenter.PAYLOADS.modalShown.name.shopTheLook
            }
        );
    });

    window.addEventListener('resize', throttle(function () {
        $('.shop-the-look-card__sizes-info').css('top', '').css('bottom', '').css('max-height', '');
    }, 300));
});
